package com.devi3east.bashbuddy.common.service

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

object ForceUpdateManager {

    private val _requiresUpdate = MutableStateFlow(false)
    val requiresUpdate = _requiresUpdate.asStateFlow()

    fun enable() {
        _requiresUpdate.value = true
    }

    fun set(value: Boolean) {
        _requiresUpdate.value = value
    }

    fun reset() {
        _requiresUpdate.value = false
    }
}